import {
  Component,
  forwardRef,
  EventEmitter,
  Output,
  AfterViewInit,
  OnDestroy,
  OnChanges,
  Inject,
  HostListener,
  ChangeDetectionStrategy,
  ViewChild,
  Input,
  TemplateRef,
} from "@angular/core";
import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
  FormGroup,
  FormBuilder,
  Validators,
} from "@angular/forms";
import { StudyReportEdit } from "../../../../model/study-report-edit";
import { AngularEditorConfig } from "@kolkov/angular-editor";
import { StudyReportWizardService } from "../../../../services/wizard/study-report/study-report.wizard.service";
import { NotificationToastService } from "../../../../services/notification-toast.service";
import { MatDialog, MatTableDataSource } from "@angular/material";
import { SafeResourceUrl } from "@angular/platform-browser";
import {
  StudyReportPhysicianSignatureDialogComponent,
  StudyReportPhysicianSignatureDialogRequest,
  StudyReportPhysicianSignatureDialogResult,
} from "../../../dialogs/study-report-physician-signature/study-report-physician-signature-dialog.component";
import {
  StudyReportTemplateDialogRequest,
  StudyReportTemplateDialogComponent,
} from "../../../dialogs/study-report-template/study-report-template-dialog.component";
import {
  StudyReportViewerDialogComponent,
  StudyReportViewerDialogRequest,
  StudyReportViewerDialogResponse,
} from "../../../dialogs/study-report-viewer/study-report-viewer-dialog.component";
import { AuthService } from "../../../../services/auth.service";
import { ServerTimeService } from "../../../../services/server-time.service";
import { ReportViewer } from "../../../../model/report-viewer";
import {
  PacsService,
  pacsServiceFactory,
} from "src/app/services/pacs/pacs.service";
import { DataService } from "src/app/services/data.service";
import { StudyReportService } from "../../../../services/study-report/study-report.service";
import { ImageFromClipboardEventService } from "../../../../services/image-from-clipboard-event.service";
import { StudyReportUploadService } from "../../../../services/study-report/study-report-upload.service";
import { getBaseUrl } from "../../../../app.module";
import { PreviousStudiesDigitizedShowDialogComponent } from "src/app/components/dialogs/previous-studies-digitized-show-dialog/previous-studies-digitized-show-dialog.component";
import { EnvironmentPresetService } from "../../../../services/environment-preset/environment-preset.service";
import { EnvironmentPreset } from "src/app/model/environment-preset";

import {
  StructuredDiagnosisColumn,
  StructuredDiagnosisColumnItem,
  StudykeyImage,
} from "src/app/model/study-report-text";
import { StudyReportKeyImageViewerDialogComponent } from "src/app/components/dialogs/study-report-key-image-viewer-dialog/study-report-key-image-viewer-dialog.component";
import { KeyImageService } from "src/app/services/key-image/key-image.service";
import { MedicalRecordIntegrationService } from "src/app/services/medical-record-integration/medical-record-integration.service";
import { TxtControlEditorComponent } from "../../txt-control-editor/txt-control-editor.component";
declare var tinymce: any;

export const STUDY_REPORT_EDIT_CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  // tslint:disable-next-line: no-use-before-declare
  useExisting: forwardRef(() => StudyReportEditTxControlComponent),
  multi: true,
};

@Component({
  selector: "app-study-report-edit-tx-control",
  providers: [STUDY_REPORT_EDIT_CONTROL_VALUE_ACCESSOR],
  templateUrl: "./study-report-edit-tx-control.component.html",
  styleUrls: ["./study-report-edit-tx-control.component.css"],
})
export class StudyReportEditTxControlComponent
  implements ControlValueAccessor, AfterViewInit
{
  @Input() noFooter: boolean = false;
  onChange;
  hideElement = true;
  uploading = false;
  form: FormGroup;
  loading: boolean;
  editorUsing: string;
  isDisabled: boolean;
  visualizeConclusion: boolean;
  protocol: string;
  importingImages: boolean;
  patientId: number;
  medicalAppointmentId: number;
  centerId: number;
  accessionNumbers: number[];
  patientFullName: string;
  diagnostic: string;
  patientAge: string;
  appointmentDate?: Date;
  dataSourcePrincipal = new MatTableDataSource([]);
  displayColumnsPrincipal = [
    "PracticeRegionName",
    "Quantity",
    "AccessionNumber",
    "PacsViewer",
  ];
  @Output() confirm: EventEmitter<any> = new EventEmitter();
  autoSaveDate: Date;
  editor;
  uploadingImage;
  private pacsService: PacsService;
  private autoSaveTimer: any = null;

  structuredDiagnosisColumns: StructuredDiagnosisColumn[] = [];
  structuredDiagnosisColumnItems: StructuredDiagnosisColumnItem[] = [];

  @ViewChild("txtControlEditor", { static: false })
  txtControlEditor!: TxtControlEditorComponent;

  text: string;
  header: string;

  constructor(
    private studyReportWizardService: StudyReportWizardService,
    private notificationToastService: NotificationToastService,
    private formBuilder: FormBuilder,
    private authService: AuthService,
    private serverTimeService: ServerTimeService,
    private studyReportService: StudyReportService,
    private medicalRecordIntegrationService: MedicalRecordIntegrationService,
    private sruService: StudyReportUploadService,
    private keyImageService: KeyImageService,
    private dialog: MatDialog,
    private dataService: DataService,
    private environmentPresetService: EnvironmentPresetService,
    @Inject("BASE_URL") private baseUrl: string,
  ) {
    this.pacsService = pacsServiceFactory(
      dataService,
      authService,
      environmentPresetService,
      baseUrl,
    );

    this.form = this.formBuilder.group({
      PhysicianId: [null, [Validators.required]],
      StudyReportId: [null, [Validators.required]],
      PatientId: [null, [Validators.required]],
      MedicalApponitmentId: [null, [Validators.required]],
      StudyReportText: ["", [Validators.required]],
      StudyReportPdf: [null],
      StudyReportConclusion: [""],
      Protocol: [""],
      ServiceName: [""],
      PracticeName: [""],
      DeliveryDate: [null],
      PhysicianSignatureOne: [null],
      PhysicianSignatureTwo: [null],
      PhysicianSignatureThree: [null],
      PhysicianSignatureFour: [null],
      PhysicianSignatureFive: [null],
      PhysicianSignatureSix: [null],
      KeyImageIds: [[]],
    });
  }
  ngAfterViewInit(): void {}

  async medicalRecordPublish() {
    try {
      const url = await this.medicalRecordIntegrationService.open(
        this.medicalAppointmentId,
        false,
      );

      window.open(url, "_blank");
    } catch (err) {
      this.notificationToastService.error(
        err.error.ExceptionMessage,
        "Atención paciente",
      );
    }
  }

  onImagesPasted(files: File[]) {
    for (const file of files) {
      this.uploadingImage = true;
      this.sruService
        .studyReportImageUpload(this.form.controls.StudyReportId.value, file)
        .then((value) => {
          this.editor.execCommand(
            "mceInsertContent",
            false,
            `<img src="${value}" alt="" />`,
          );
          this.uploadingImage = false;
        })
        .catch((err) => {
          this.notificationToastService.error(JSON.stringify(err), "Informe");
          this.uploadingImage = false;
        });
    }
  }

  async editChange() {
    // const document = await this.txtControlEditor.getDocument();

    const studyReportEdit = <StudyReportEdit>this.form.getRawValue();
    // studyReportEdit.StudyReportText = document.html;

    if (this.onChange) {
      this.onChange(studyReportEdit);
    }
  }

  async getText() {
    const document = await this.getDocument();
    return document.internalUnicodeFormat;
  }

  getPhysicianSignatureOne(obj: StudyReportEdit): number {
    const physicianId = this.authService.getPhysicianId()
      ? +this.authService.getPhysicianId()
      : null;
    if (
      !obj.PhysicianSignatureOne &&
      !obj.PhysicianSignatureTwo &&
      !obj.PhysicianSignatureThree &&
      !obj.PhysicianSignatureFour &&
      !obj.PhysicianSignatureFive &&
      !obj.PhysicianSignatureSix
    ) {
      return physicianId;
    } else {
      return obj.PhysicianSignatureOne;
    }
  }

  replaceImgUrl(texto: string): string {
    let cant = 7;
    let index1 = texto.indexOf("http://");
    if (index1 === -1) {
      index1 = texto.indexOf("https://");
      cant = 8;
    }

    const index2 = texto.indexOf("/", index1 + cant);
    const aReemplazar = texto.substring(index1, index2 + 1);
    const urlBase = getBaseUrl();

    while (
      index1 > -1 &&
      urlBase.indexOf(aReemplazar) === -1 &&
      texto.indexOf(aReemplazar) > -1
    ) {
      texto = texto.replace(aReemplazar, urlBase);
    }

    return texto;
  }

  replaceTextP(texto: string): string {
    const oldText = "p>";
    const newText = "div>";
    while (texto.indexOf(oldText) > -1) texto = texto.replace(oldText, newText);
    return texto;
  }

  async writeValue(obj: StudyReportEdit) {
    if (obj) {
      this.studyReportWizardService.getStudyReportEditInfo().then((info) => {
        this.medicalAppointmentId = obj.MedicalApponitmentId;
        this.patientId = info.PatientId;
        this.accessionNumbers = info.AccessionNumbers;
        this.centerId = info.CenterId;
        this.visualizeConclusion = info.VisualizeConclusion;
        this.patientAge = info.PatientAge;
        this.patientFullName = info.PatientFullName;
        this.diagnostic = info.Diagnostic;
        this.appointmentDate = info.AppointmentDate;
        this.protocol =
          this.studyReportWizardService.getMedicalOrderOperation().Protocol;
        this.structuredDiagnosisColumnItems =
          info.StructuredDiagnosisColumnItems;
        this.structuredDiagnosisColumns = info.StructuredDiagnosisColumns;
        this.dataSourcePrincipal = new MatTableDataSource(
          info.MedicalAppointmentProcedures,
        );

        if (
          this.studyReportWizardService.studykeyImage.KeyImageIds.length ===
            0 &&
          this.accessionNumbers &&
          this.accessionNumbers.length > 0
        ) {
          this.importKeyImages();
        } else {
          this.form.patchValue({
            KeyImageIds: obj.KeyImageIds,
          });
        }
      });

      if (obj.StudyReportText) {
        obj.StudyReportText = this.replaceImgUrl(obj.StudyReportText);
        this.text = obj.StudyReportText;
      }

      this.form.patchValue({
        PhysicianId: obj.PhysicianId,
        StudyReportId: obj.StudyReportId,
        StudyReportText: obj.StudyReportText,
        StudyReportConclusion: obj.StudyReportConclusion,
        MedicalApponitmentId: obj.MedicalApponitmentId,
        Protocol: obj.Protocol,
        PatientId: obj.PatientId,
        PracticeName: obj.PracticeName,
        ServiceName: obj.ServiceName,
        DeliveryDate: obj.DeliveryDate,
        PhysicianSignatureOne: this.getPhysicianSignatureOne(obj),
        PhysicianSignatureTwo: obj.PhysicianSignatureTwo,
        PhysicianSignatureThree: obj.PhysicianSignatureThree,
        PhysicianSignatureFour: obj.PhysicianSignatureFour,
        PhysicianSignatureFive: obj.PhysicianSignatureFive,
        PhysicianSignatureSix: obj.PhysicianSignatureSix,
      });

      this.isDisabled = this.studyReportWizardService.isReadOnly;

      // el autoguardado se dispara desde onTxTextChange() al recibir el evento textChange del editor

      if (!obj.StudyReportText) {
        const htmlSections =
          await this.studyReportService.getStudyReportSections(
            <StudyReportEdit>this.form.getRawValue(),
          );

        this.header = htmlSections.HeaderHtml;
      }

      this.form.valueChanges.subscribe(() => {
        this.editChange();
      });
    }
  }

  onTxTextChange(): void {
    if (this.isDisabled) {
      return;
    }

    const document = this.txtControlEditor.getInternalUnicodeFormat().then((document) => {
      this.changeText(document);

      this.studyReportService
        .studyReportDirectTypingUpdate(<StudyReportEdit>this.form.getRawValue())
        .then(() => {
          this.serverTimeService.getDateTimeNow().then((date) => {
            this.autoSaveDate = date;
          });
        })
        .catch((err) => console.log(err));
    });
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {}

  setDisabledState?(isDisabled: boolean): void {}

  studyReportSafeResourceUrl(): SafeResourceUrl {
    return this.studyReportWizardService.getStudyReportPdfSafeResourceUrl();
  }

  focus(editor: string): void {
    this.editorUsing = editor;
  }

  isValidSelectedImagesKeys(): boolean {
    if (
      this.studyReportWizardService.studykeyImage &&
      this.studyReportWizardService.studykeyImage.SelectedKeyImageIds &&
      this.studyReportWizardService.studykeyImage.SelectedKeyImageIds.length > 0
    ) {
      return (
        this.studyReportWizardService.studykeyImage.PatientId === this.patientId
      );
    }

    return true;
  }

  isValidImagesKeys(): boolean {
    if (
      this.studyReportWizardService.studykeyImage &&
      this.studyReportWizardService.studykeyImage.KeyImageIds &&
      this.studyReportWizardService.studykeyImage.KeyImageIds.length > 0
    ) {
      return (
        this.studyReportWizardService.studykeyImage.PatientId === this.patientId
      );
    }

    return true;
  }

  importKeyImages() {
    this.studyReportWizardService.clearImagesKeys();

    this.form.patchValue({ KeyImageIds: [] });
    if (this.accessionNumbers && this.accessionNumbers.length > 0) {
      this.importingImages = true;
      this.keyImageService
        .importKeyImage(this.patientId, this.accessionNumbers[0], this.centerId)
        .then((imageKeys) => {
          this.studyReportWizardService.studykeyImage = imageKeys;

          if (!this.isValidImagesKeys()) {
            this.notificationToastService.error(
              "Error en las imágenes vinculadas, por favor reimporte las imágenes",
              "Informe",
            );
            this.importingImages = false;
            this.studyReportWizardService.clearImagesKeys();
            return;
          }

          this.form.patchValue({ KeyImageIds: imageKeys.KeyImageIds });
          this.importingImages = false;

          if (
            this.studyReportWizardService.studykeyImage.KeyImageIds.length === 0
          ) {
            this.notificationToastService.info(
              "No se encontraron imágenes vincualadas",
              "Informe",
            );
          } else {
            this.notificationToastService.success(
              "Se importaron las imágenes correctamente",
              "Informe",
            );
          }
        })
        .catch((err) => {
          this.importingImages = false;
          this.notificationToastService.error(JSON.stringify(err), "Informes");
        });
    } else {
      this.notificationToastService.error(
        "No se encontraron imágenes vincualadas",
        "Informe",
      );
    }
  }

  openAttachments(template: TemplateRef<void>) {
    const dialogRef = this.dialog.open(template, {
      width: "90%",
      height: "600px",
    });
    dialogRef.afterClosed().subscribe((ids: number[] | undefined) => {
      if (ids) {
        this.studyReportWizardService.selectedAttachmentIds = ids;
      }
    });
  }

  viewKeyImages() {
    if (!this.isValidImagesKeys()) {
      this.notificationToastService.error(
        "Error en las imágenes vinculadas, por favor reimporte las imágenes",
        "Informe",
      );
      return;
    }

    const dialogRef = this.dialog.open(
      StudyReportKeyImageViewerDialogComponent,
      {
        width: "90%",
        height: "600px",
        data: {
          studyReportId: this.form.controls.StudyReportId.value,
          keyImageIds: this.studyReportWizardService.studykeyImage.KeyImageIds,
        },
      },
    );

    dialogRef.afterClosed().subscribe(async (result: string[]) => {
      if (result) {
        this.studyReportWizardService.studykeyImage.SelectedKeyImageIds =
          result;
        this.form.patchValue({ KeyImageIds: result });
      }
    });
  }

  async viewImages(accessionNumber: string = "") {
    try {
      const url = await this.pacsService.pacsViewerInfo(
        this.studyReportWizardService.studyReportId,
        accessionNumber,
      );
      window.open(url, "_blank");
    } catch (err) {
      console.log(err);
      this.notificationToastService.error(JSON.stringify(err), "Informe");
    }
  }

  changeText(content: string) {
    this.form.patchValue({ StudyReportText: content });
  }

  async refreshStudyReportPdf() {
    if (!this.isValidSelectedImagesKeys()) {
      this.notificationToastService.error(
        "Error en las imágenes vinculadas, por favor reimporte las imágenes",
        "Informe",
      );
      return;
    }

    const document = await this.getDocument();

    this.changeText(document.internalUnicodeFormat);

    this.form.patchValue({ StudyReportPdf: document.pdf });
    this.form.patchValue({ StudyReportText: document.internalUnicodeFormat });

    const edit = <StudyReportEdit>this.form.getRawValue();

    if (this.onChange) {
      this.onChange(edit);
    }

    if (!this.form.invalid) {
      const studyReportViewerDialogRequest =
        new StudyReportViewerDialogRequest();

      studyReportViewerDialogRequest.ForceServerReportViewer = true;
      studyReportViewerDialogRequest.CanConfirm = true;
      studyReportViewerDialogRequest.StudyReportEdit = edit;
      studyReportViewerDialogRequest.studyReportWizard =
        this.studyReportWizardService.studyReportWizard;
      studyReportViewerDialogRequest.StructuredDiagnosisColumnItems =
        this.structuredDiagnosisColumnItems;
      studyReportViewerDialogRequest.StructuredDiagnosisColumns =
        this.structuredDiagnosisColumns;
      studyReportViewerDialogRequest.StudyReportEdit.TypeModality = 2;

        studyReportViewerDialogRequest.StudyReportEdit.AttachmentIds = this
        .studyReportWizardService.selectedAttachmentIds
        ? this.studyReportWizardService.selectedAttachmentIds
        : [];

      studyReportViewerDialogRequest.StudyReportEdit.KeyImageIds = this
        .studyReportWizardService.studykeyImage
        ? this.studyReportWizardService.studykeyImage.SelectedKeyImageIds
        : null;

      studyReportViewerDialogRequest.PdfBase64 = document.pdf;

      const dialogRef = this.dialog.open(StudyReportViewerDialogComponent, {
        width: "90%",
        height: "600px",
        data: studyReportViewerDialogRequest,
      });

      dialogRef
        .afterClosed()
        .subscribe(async (result: StudyReportViewerDialogResponse) => {
          if (result && result.ReportViewer) {
            this.confirm.emit({
              reportViewer: result.ReportViewer,
              structuredDiagnosisColumnItems:
                this.structuredDiagnosisColumnItems,
            });
          }
        });
    }
  }

  async getDocument() {
    const htmlSections = await this.studyReportService.getStudyReportSections(
      <StudyReportEdit>this.form.getRawValue(),
    );

    const document = await this.txtControlEditor.getDocument(
      htmlSections.HeaderHtml,
      htmlSections.FooterHtml,
    );
    return document;
  }

  openPreviusStudiesShowDialog() {
    const medicalAppointmentId = this.form.controls.MedicalApponitmentId.value;
    this.dialog.open(PreviousStudiesDigitizedShowDialogComponent, {
      width: "50%",
      data: medicalAppointmentId,
    });
  }

  async openStudyReportPhysicianSignatureDialog() {
    const edit = <StudyReportEdit>this.form.getRawValue();
    const studyReportPhysicianSignatureDialogRequest =
      new StudyReportPhysicianSignatureDialogRequest();
    studyReportPhysicianSignatureDialogRequest.PhysicianIdSignatureOne =
      edit.PhysicianSignatureOne;
    studyReportPhysicianSignatureDialogRequest.PhysicianIdSignatureTwo =
      edit.PhysicianSignatureTwo;
    studyReportPhysicianSignatureDialogRequest.PhysicianIdSignatureThree =
      edit.PhysicianSignatureThree;
    studyReportPhysicianSignatureDialogRequest.PhysicianIdSignatureFour =
      edit.PhysicianSignatureFour;
    studyReportPhysicianSignatureDialogRequest.PhysicianIdSignatureFive =
      edit.PhysicianSignatureFive;
    studyReportPhysicianSignatureDialogRequest.PhysicianIdSignatureSix =
      edit.PhysicianSignatureSix;

    const dialogRef = this.dialog.open(
      StudyReportPhysicianSignatureDialogComponent,
      {
        width: "50%",
        height: "500px",
        data: studyReportPhysicianSignatureDialogRequest,
      },
    );

    dialogRef
      .afterClosed()
      .subscribe((result: StudyReportPhysicianSignatureDialogResult) => {
        if (result) {
          this.form.patchValue({
            PhysicianSignatureOne:
              result.PhysicianSignatureOne != null
                ? result.PhysicianSignatureOne.Id
                : null,
            PhysicianSignatureTwo:
              result.PhysicianSignatureTwo != null
                ? result.PhysicianSignatureTwo.Id
                : null,
            PhysicianSignatureThree:
              result.PhysicianSignatureThree != null
                ? result.PhysicianSignatureThree.Id
                : null,
            PhysicianSignatureFour:
              result.PhysicianSignatureFour != null
                ? result.PhysicianSignatureFour.Id
                : null,
            PhysicianSignatureFive:
              result.PhysicianSignatureFive != null
                ? result.PhysicianSignatureFive.Id
                : null,
            PhysicianSignatureSix:
              result.PhysicianSignatureSix != null
                ? result.PhysicianSignatureSix.Id
                : null,
          });
        }
      });
  }

  async openStudyReportTemplateFiltersDialog() {
    const edit = <StudyReportEdit>this.form.getRawValue();
    const studyReportTemplateDialogRequest =
      new StudyReportTemplateDialogRequest();
    studyReportTemplateDialogRequest.PhysicianId = edit.PhysicianId;
    studyReportTemplateDialogRequest.StudyReportId = edit.StudyReportId;
    studyReportTemplateDialogRequest.EditorId = 2;

    const dialogRef = this.dialog.open(StudyReportTemplateDialogComponent, {
      width: "50%",
      maxHeight: "500px",
      data: studyReportTemplateDialogRequest,
    });

    dialogRef.afterClosed().subscribe((result: string[]) => {
      if (!result) {
        return;
      }

      this.studyReportService
        .getStudyReportSections(<StudyReportEdit>this.form.getRawValue())
        .then((htmlSections) => {
          this.txtControlEditor.addTemplate(
            result,
            htmlSections.HeaderHtml,
            htmlSections.FooterHtml,
          );
        });
    });
  }

  uploadFile(event) {
    for (let index = 0; index < event.length; index++) {
      const element = event[index];
      const reader = new FileReader();
      reader.readAsDataURL(element);
      this.uploading = true;
      reader.onload = (_event) => {
        this.form.patchValue({ StudyReportText: null });
        const base64Url = <string>reader.result;
        let pdfBase64 = base64Url.split("base64,")[1];
        this.uploading = false;

        const edit = <StudyReportEdit>this.form.getRawValue();
        edit.StudyReportText = null;
        edit.StudyReportPdf = pdfBase64;
        const studyReportViewerDialogRequest =
          new StudyReportViewerDialogRequest();
        studyReportViewerDialogRequest.CanConfirm = true;
        studyReportViewerDialogRequest.StudyReportEdit = edit;
        studyReportViewerDialogRequest.studyReportWizard =
          this.studyReportWizardService.studyReportWizard;

        studyReportViewerDialogRequest.StructuredDiagnosisColumnItems =
          this.structuredDiagnosisColumnItems;

        studyReportViewerDialogRequest.StructuredDiagnosisColumns =
          this.structuredDiagnosisColumns;

        const dialogRef = this.dialog.open(StudyReportViewerDialogComponent, {
          width: "90%",
          height: "600px",
          data: studyReportViewerDialogRequest,
        });

        dialogRef
          .afterClosed()
          .subscribe(async (result: StudyReportViewerDialogResponse) => {
            if (result && result.ReportViewer) {
              this.form.patchValue({ StudyReportPdf: pdfBase64 });

              this.confirm.emit({
                reportViewer: result.ReportViewer,
                structuredDiagnosisColumnItems:
                  this.structuredDiagnosisColumnItems,
              });
            }
          });
      };
    }
  }
}
